import {BiReset} from 'react-icons/bi';
import {Accordion, Button, ColorPicker} from '../../../../components';
import {useViewerStore} from "../../../../store/store";
import {Alert} from "antd";
import {wallData} from '../../../../Constants';

const WallSiding = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const wallSelectedColor = useViewerStore(state => state.wallSelectedColor);
    const changeWallTextureHandler = (e: React.MouseEvent<HTMLImageElement>) => {
    // remove active class from all li
        const li = document.querySelectorAll('.pattern__img');
        li.forEach((item) => {
            item.classList.remove('active');
        });

        const target = e.target as HTMLImageElement;
        const parent = target.parentNode as HTMLElement;
        parent.classList.add('active');

        const textureId = target.getAttribute('data-texture-id');
        if (textureId) {
            sceneViewer.setMeshTexture(sceneViewer.wallMeshArr, target.src, "wall", textureId);
        }
    };

    const resetWallTextureHandler = () => sceneViewer.resetWallToDefault();

    const handleWallColorChange = (color: string) => {
        useViewerStore.setState({wallSelectedColor: color});
        sceneViewer.setMeshMaterialColor(sceneViewer.wallMeshArr, color);
    }

    return (
        <>
            <div className="tab__inner">
                <div className="tab__title">
                    <span className="tab__title--text">Wall Siding</span>
                    <div className="tab__title--btns">
                        <Button
                            style={{
                                display: 'none',
                            }}
                            onClick={resetWallTextureHandler}
                            variant='btn-clear'
                            size='btn-resize'
                            title={'Reset to Default'}>
                            <BiReset />
                        </Button>
                    </div>
                </div>

                <div className="tab__column">
                    <Accordion title='Select Wall Style' active={true}>
                        <ul className='pattern'>
                            {wallData.map((item, index) => (
                                <li className='pattern__item' key={index}>
                                    <Button
                                        variant='btn-clear'
                                        size='btn-resize'
                                        className='pattern__img'
                                        title={item.alt}
                                    >
                                        <img style={{}} onClick={changeWallTextureHandler} src={item.img} alt={item.alt}
                                             data-texture-id={item.id}/>
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </Accordion>
                </div>

                <div className="tab__column">
                    <div className="tab__flex justify-between mb-1">
                        <span className="tab__column--subtitle">Wall Color</span>
                        <ColorPicker
                            currentColor={wallSelectedColor}
                            changeHandler={handleWallColorChange}/>
                    </div>
                    <Alert 
                        className="tab__color-picker-alert"
                        message="Dark mode extensions may cause unexpected behavior with the color picker. Please disable any related extensions and use oneDRAW's built-in dark mode to proceed."
                        type='warning'
                        showIcon
                    />
                </div>
            </div>
        </>
    );
};

export default WallSiding;
